export type StorefrontPlacementScope = 'section' | 'content';

export const STOREFRONT_SECTION_PLACEMENT_KEYS = [
  'home.hero',
  'home.featured-products',
  'home.featured-categories',
  'home.newest',
  'home.promoted',
  'home.campaign',
  'home.trust'
] as const;

export const STOREFRONT_CONTENT_PLACEMENT_KEYS = [
  'footer.trust',
  'footer.policy',
  'header.banner',
  'sidebar.promo'
] as const;

export const STOREFRONT_NAV_LOCATION_KEYS = [
  'header',
  'footer',
  'mobile',
  'sidebar'
] as const;

export const STOREFRONT_SECTION_RULE_KEYS = [
  'featured-offerings',
  'featured_categories',
  'latest-categories',
  'newest',
  'best_selling',
  'top-sellers',
  'promoted',
  'manual-curation'
] as const;

export const STOREFRONT_CONTENT_FORMATS = [
  'Markdown',
  'Html',
  'PlainText'
] as const;

export const STOREFRONT_NAV_TARGET_TYPES = [
  'Route',
  'Category',
  'Offering'
] as const;
